import { NativeSelect } from "lib/miolo";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";

const RealEstateFundManagementMenu = connectMenu<MenuProvided>(({ refine, currentRefinement }) => {
  return (
    <div className="space-y-4">
      <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Gestão</h3>

      <NativeSelect value={currentRefinement || ""} onChange={(event) => refine(event.currentTarget.value || "")}>
        <option value="">Todos</option>
        <option value="Ativa">Ativa</option>
        <option value="Passiva">Passiva</option>
      </NativeSelect>
    </div>
  );
});

export default function RealEstateFundManagement() {
  return <RealEstateFundManagementMenu attribute="management" />;
}
